import React, { useEffect } from "react";
import clsx from "clsx";
import { Dropdown } from "react-bootstrap";
import HeaderDropdownToggle from "../content/CustomDropdowns/HeaderDropdownToggle";
import { ReactComponent as SunIcon } from "../../../_metronic/layout/assets/layout-svg-icons/Sun.svg";
import { saveUserPreferences } from "../../services/usersService";
import { useGlobalData } from "../../../provider/GlobalDataProvider";

function UIAsideSkin({ iconType }) {
  const { userPreferences, reload, setReload } = useGlobalData();

  useEffect(() => {}, [reload]);

  return (
    <Dropdown
      className="kt-header__topbar-item kt-header__topbar-item--langs"
      drop="down"
      alignRight
    >
      <Dropdown.Toggle as={HeaderDropdownToggle} id="dropdown-toggle-my-cart">
        <span
          className={clsx("kt-header__topbar-icon", {
            "kt-header__topbar-icon--brand": iconType === "brand",
          })}
        >
          <SunIcon />
        </span>
      </Dropdown.Toggle>
      <Dropdown.Menu className="dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround">
        <ul className="kt-nav kt-margin-t-10 kt-margin-b-10">
          <li
            className={clsx("kt-nav__item", {
              "kt-nav__item--active": userPreferences.lightAsideSkin === true,
            })}
          >
            <span
              onClick={async () => {
                saveUserPreferences({
                  ID: userPreferences.ID,
                  userID: userPreferences.userID,
                  lightAsideSkin: true,
                  darkAsideSkin: false,
                  lightText: userPreferences.lightText,
                  darkText: userPreferences.darkText,
                  invifoThemeID: userPreferences.invifoThemeID,
                  customThemeID: userPreferences.customThemeID,
                  language: userPreferences.language,
                  menuLayout: userPreferences.menuLayout,
                }).then((response) => {
                  setReload(reload + 1);
                });
              }}
              className={clsx("kt-nav__link", {
                "kt-nav__link--active": userPreferences.lightAsideSkin === true,
              })}
            >
              <span className="kt-nav__link-icon">
                <i className="fas fa-sun"></i>
              </span>
              <span className="kt-nav__link-text">Light Aside</span>
            </span>
          </li>
          <li
            className={clsx("kt-nav__item", {
              "kt-nav__item--active": userPreferences.darkAsideSkin === true,
            })}
          >
            <span
              onClick={async () => {
                saveUserPreferences({
                  ID: userPreferences.ID,
                  userID: userPreferences.userID,
                  lightAsideSkin: false,
                  darkAsideSkin: true,
                  lightText: userPreferences.lightText,
                  darkText: userPreferences.darkText,
                  invifoThemeID: userPreferences.invifoThemeID,
                  customThemeID: userPreferences.customThemeID,
                  language: userPreferences.language,
                  menuLayout: userPreferences.menuLayout,
                }).then((response) => {
                  setReload(reload + 1);
                });
              }}
              className={clsx("kt-nav__link", {
                "kt-nav__link--active": userPreferences.darkAsideSkin === true,
              })}
            >
              <span className="kt-nav__link-icon">
                <i className="fas fa-moon"></i>
              </span>
              <span className="kt-nav__link-text">Dark Aside</span>
            </span>
          </li>
        </ul>
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default UIAsideSkin;
